<template>
<div class="animated fadeIn">
  <div class="splash" v-if="!preloadDone">
    <div class="container  d-flex h-100">
      <div class="row justify-content-center text-primary w-100 align-self-center text-white">
        <i class="fa fa-spin fa-spinner"></i>
      </div>
    </div>
  </div>
  <form enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event,false)" v-if="preloadDone" novalidate>
    <div class="row justify-content-md-center mt-5">
      <div class="col-md-4">
        <b-card>
          <div slot="header">
            <strong>Dados de utilizador</strong>
          </div>
          <b-form-fieldset label="Nome">
            <b-form-input type="text" name="name" v-model="item.name" placeholder="Nome"  v-validate="'required'" :state="validateState('name')"></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('name') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>
          <b-form-fieldset label="Email">
            <b-form-input type="email" name="email" v-model="item.email" placeholder="Email" v-validate="{ required: true, email:true, uniqueemail: item.id }" :state="validateState('email')" data-vv-validate-on="change" ></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('email') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>
          <b-form-fieldset label="Nome de utilizador">
            <b-form-input id="itemName" type="text" name="username" v-model="item.username" placeholder="Nome de utilizador"  v-validate="{ username: item.id, required: true, min:5 }" :state="validateState('username')" data-vv-validate-on="change"></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('username') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>
          <b-form-fieldset label="Palavra-passe">
            <b-form-input type="password" name="password" v-model="item.password" placeholder="Palavra-passe" v-validate="{min: 8}" :state="validateState('password')" ref="password"></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('password') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>
          <b-form-fieldset label="Confirme a palavra-passe">
            <b-form-input type="password" name="password_confirm" v-model="item.password_confirm" placeholder="Confirme a palavra-passe" v-validate="{confirmed: 'password', required:passwordRequired}" :state="validateState('password_confirm')"></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('password_confirm') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>
          <div slot="footer">
            <div class="row">
              <div class="col-sm-3">
                <router-link :to="{name:'dashboard'}" size="sm" variant="danger"><i class="fa fa-ban"></i> Cancelar</router-link>

              </div>
              <div class="col-sm-9 text-right">
                <b-button type="submit" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar</b-button>
                <b-button type="button" v-on:click="validateBeforeSubmit($event,true)" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar e fechar</b-button>
              </div>
            </div>
          </div>
        </b-card>
      </div>
      <!--/.col-->
    </div>
  </form>
</div>
</template>

<script>
export default {
  name: 'Profile',
  data() {
    return {
      preloadDone: false,
      item: {
        name: '',
        password_confirm: '',
        password: ''
      },
      roles: []
    }
  },
  computed: {
    passwordRequired: function() {
      return this.item.password.length > 0
    }
  },
  methods: {
    submit(e, close) {
      var data = {
        data: this.item
      }
      this.axios.put('users/profile', data)
        .then(response => {
          this.item = response.data.data
          this.$toastr('success', 'perfil atualizado com sucesso', 'Gravado')
          if (close) {
            this.$router.push({
              name: 'dashboard'
            })
          }
        })
        .catch(response => {
          this.$toastr('error', 'Não foi possivel gravar', 'Erro')
        })
    },
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$toastr('error', 'Tem campos inválidos', 'Erro')
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    }
  },
  created() {
    this.axios.get('users/profile')
      .then(response => {
        this.item = response.data.data
        this.preloadDone = true
      })
      .catch(response => {
        this.$toastr('error', 'Este utilizador não existe', 'Erro')
        this.$router.push({
          name: 'dashboard'
        })
      })
  }
}
</script>



// WEBPACK FOOTER //
// Profile.vue?3fa869f5